export * from './Page_DiseaseProfile/index.js';
export * from './Page_DiseaseProfile_Header/Page_DiseaseProfile_Header.js';
//# sourceMappingURL=index.js.map